import axios from "axios";
import { CMSPath_Master } from "../../config/Constant";


const base_url_gha = axios.create({ baseURL: `${CMSPath_Master}/RewardsApiApp/rest`, timeout: 15000 });

export const GHAWelcomePageFetchHTML = async () => {
    try {
        const data = await axios.get(`${CMSPath_Master}/Connector/rest/assets?type=rewardsProgramHtml&languageCode=en`, { timeout: 15000 });
        // console.log("api WELCOME PAGE HTML RESPONSE", data.data)
        return data.data;
        

    } catch (err) {
        console.log('Error',err);
        throw new Error(err);
    
    }
}

export const fetchAvailableLanguages = async () => {
    try {
        const res = await base_url_gha.get("/lov?type=language",
            { headers: { "Authorization": `Bearer 078f0d79-8ea9-41e5-b122-b56462c842a7` } });
        return res;
    }
    catch (err) {
        throw new Error((err.response))
    }

}